module.exports = __webpack_public_path__ + "img/health4_7-9-2021.9247518d.jpg";